export default "__VITE_ASSET__DnsHxfGI__"